import React from "react";
import Marquee from "react-fast-marquee";
import { Skull } from "lucide-react";

const CautionTape = ({ text, rotate = "-rotate-2", speed = 60 }) => {
  return (
    <div
      className={`relative w-screen left-1/2 -translate-x-1/2 my-6 ${rotate} select-none`}
      data-testid="caution-tape"
    >
      <div className="caution-tape border-y-4 border-black py-2">
        <Marquee gradient={false} speed={speed} pauseOnHover>
          <div className="flex items-center gap-6 pr-6 font-mono-display text-sm font-bold uppercase tracking-[0.3em] text-black">
            {Array.from({ length: 6 }).map((_, i) => (
              <span key={i} className="flex items-center gap-3 px-2 py-1 bg-[#FFE600]">
                <Skull className="w-4 h-4" strokeWidth={2.5} />
                {text}
              </span>
            ))}
          </div>
        </Marquee>
      </div>
    </div>
  );
};

export default CautionTape;
